export default __webpack_public_path__ + "static/media/category-58.e32f29dd.svg";